import { Box, Typography } from '@mui/material';
import Button from '../../foundation/Button';
import CustomBR from '../../foundation/CustomBR';
import { CenteredFlex } from '../../foundation/Flex';
import DialogWithHeader from '../../foundation/DialogWithHeader';
import SubscriptionPlans from '../../components/SubscriptionPlans';

export type ElpPackagesModalProps = {
    open: boolean
    onClose: () => void
}

const BACKOFFICE_PACKAGES_URL = '/backoffice/employers/buy-promoted-jobs';

const ElpPackagesModal = ({ open, onClose }: ElpPackagesModalProps): JSX.Element => {
    const goToBackoffice = () => {
        window.location.assign(BACKOFFICE_PACKAGES_URL);
    };

    return (
        <DialogWithHeader
            open={open}
            onClose={onClose}
            title="בחרו את החבילה המתאימה לכם"
            fullWidth
            maxWidth="lg"
        >
            <Box>
                <Typography color="secondary" variant="body1" textAlign="center">
                    פתרונות פרסום חכמים – יותר חשיפה, יותר מועמדים, יותר הצלחות
                </Typography>
                <CustomBR times={2} />
                <SubscriptionPlans
                    showHeader={false}
                    showEnterpriseCta={false}
                    onPlanClick={goToBackoffice}
                />
                <CustomBR times={2} />
                <CenteredFlex>
                    <Button color="primary" size="large" onClick={goToBackoffice}>
                        המשך לבחירת חבילה
                    </Button>
                </CenteredFlex>
            </Box>
        </DialogWithHeader>
    );
};

export default ElpPackagesModal;
